import { render, staticRenderFns } from "./PalveluhakemusTunnistauduttu.vue?vue&type=template&id=71eab586&scoped=true&"
import script from "./PalveluhakemusTunnistauduttu.vue?vue&type=script&lang=js&"
export * from "./PalveluhakemusTunnistauduttu.vue?vue&type=script&lang=js&"
import style0 from "./PalveluhakemusTunnistauduttu.vue?vue&type=style&index=0&id=71eab586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eab586",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71eab586')) {
      api.createRecord('71eab586', component.options)
    } else {
      api.reload('71eab586', component.options)
    }
    module.hot.accept("./PalveluhakemusTunnistauduttu.vue?vue&type=template&id=71eab586&scoped=true&", function () {
      api.rerender('71eab586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PalveluhakemusTunnistauduttu.vue"
export default component.exports